



















import { defineComponent, getCurrentInstance, Ref } from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import SettingImportModal from '@/components/templates/h/SettingImportModal.vue'
import PageView from '@/components/templates/h/yosan-haibun/adjusted-dow-index/PageView.vue'
import {
  adjustedDowIndexExtractCondition,
  adjustedDowIndexOutputCondition,
  ColumnLabel,
} from '@/types/entities'
import {
  TemplateFile,
  ResourceType,
  Where,
  WhereOp,
  OrderBy,
  OrderByDirection,
  OrderByNullsOption,
  VUiPAdjustedDowIndicesCountDocument,
} from '@/types/generated/graphql'
import {
  OUTPUT_COND_ITEM,
  OUTPUT_COND_STORE,
  OUTPUT_EXTRACT_TARGET_DEFAULT,
  OUTPUT_COND_DELETE,
  SELECT_MAX_COUNT,
} from '@/utils/constant'
import { EXPORT_FILENAME } from '@/utils/constant'
// import { TemplateFile, ResourceType } from '@/types/generated/graphql'
import importExportHelper from '@/utils/importExportHelper'
import { addDayYMD } from '@/utils/mixin'
import { setWhereValue, setWhereValues } from '@/utils/searchConditionDef'
import Toast from '@/utils/toast'
const DEFAULT_OUTPUT_CONST = {
  extractTarget: OUTPUT_EXTRACT_TARGET_DEFAULT, // 出力条件（抽出対象）はデフォルト値を設定できるようにしていないため、定数を用意した
  storeOutput: [OUTPUT_COND_STORE.tanten],
  itemOutput: [OUTPUT_COND_ITEM.budgetGroup],
  delOutput: [],
}
const DEFAULT_EXTRACT_CONST = {
  validData: [addDayYMD(1), '2999-12-31'],
}
export default defineComponent({
  components: { PageView, SettingImportModal },
  layout: 'sidebar',
  created() {
    this.helper = new importExportHelper(this)
  },
  data() {
    return {
      defaultDateValue: DEFAULT_EXTRACT_CONST.validData,
      resourceType: ResourceType.UiPAdjustedDowIndex,
      templateFile: TemplateFile.UiPAdjustedDowIndex_01,
      extractCondition: {
        validData: DEFAULT_EXTRACT_CONST.validData,
        chubunrui: [],
      },
      outputCondition: DEFAULT_OUTPUT_CONST,
      outputUseList: [
        {
          outputCondType: 'Store',
          displayItems: DEFAULT_OUTPUT_CONST.storeOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.storeOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.storeOutput,
        },
        {
          outputCondType: 'Item',
          displayItems: DEFAULT_OUTPUT_CONST.itemOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.itemOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.itemOutput,
        },
        {
          outputCondType: 'Delete',
          displayItems: [OUTPUT_COND_DELETE.includeDelete],
          defaultSelected: DEFAULT_OUTPUT_CONST.delOutput,
          disabledItems: [],
        },
      ],
      totalCount: null,
      exportSpinner: false,
    }
  },
  methods: {
    changeExtractCondition(cond: adjustedDowIndexExtractCondition) {
      console.log('adjustedDowIndexExtractCondition', cond)
      this.extractCondition = cond
      this.requestCount()
    },
    changeOutputCondition(cond: adjustedDowIndexOutputCondition) {
      console.log('changeOutputCondition', cond)
      this.outputCondition = cond
      this.requestCount()
    },
    async requestCount() {
      this.exportSpinner = true
      this.totalCount = null
      if (this.checkRequired(false)) {
        try {
          const result = await this.$apollo.query({
            query: VUiPAdjustedDowIndicesCountDocument,
            variables: { where: this._createWhere() },
          })
          const data = result.data.vUiPAdjustedDowIndices.totalCount
          this.totalCount = data.toString()
          this.exportSpinner = false
        } catch (e) {
          console.error(e)
          this.exportSpinner = false
          this.totalCount = '-'
        }
      } else {
        this.exportSpinner = false
        this.totalCount = '-'
      }
    },
    /*********************************
     * 以下はインポートリクエスト用の処理
     *********************************/
    requestImport() {
      console.log('requestImport')
      this.$refs.settingImportModal.show()
    },
    /**
     * インポート開始処理
     */
    async importFileUpload(files: File[]) {
      console.log('importFileUpload', { files })
      this.helper.import({
        files: files,
        resourceType: this.resourceType,
        optionXlsx: { skipRows: 3 },
      })
    },
    //　入力チェック
    checkRequired(showToast: boolean) {
      // 入力チェック開始
      let errMsg = []
      if (
        !this.extractCondition.validData[0] ||
        !this.extractCondition.validData[1] ||
        this.extractCondition.chubunrui.length == 0
      ) {
        errMsg.push({
          message: this.$i18n.t('error.requiredItemNotInput'),
        })
      }
      // 選択数上限チェック
      if (this.extractCondition.chubunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.chubunrui'),
            selected: this.extractCondition.chubunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (errMsg.length) {
        if (showToast) {
          for (const msg of errMsg) {
            Toast.error(this, msg)
          }
        }
        // 入力チェックに引っかかった場合はエクスポートの要求を出さない
        return false
      }
      return true
    },
    /*********************************
     * 以下はエクスポートリクエスト用の処理
     *********************************/
    /**
     * エクスポート処理
     */
    async requestExport() {
      if (this.checkRequired(true)) {
        // this._create_query_string()
        this.helper.export({
          query: this._create_query_string(),
          jmespathQuery:
            'data.vUiPAdjustedDowIndices.edges[].node | map(&merge(`{"__update": null}`, @), @)',
          templateFile: this.templateFile,
          filenameExport: EXPORT_FILENAME.adjusted_dow_index,
          columnLabelMapping: this._create_column_label_mapping(),
        })
      }
    },
    _create_query_string() {
      const where = this._createWhere()
      const rowQuery = `
query {
  vUiPAdjustedDowIndices(
    where: ${this.helper.generateQueryWhereString(where)}
    orderBy: ${this._createOrderByString()}
  ) {
    edges {
      node {
        inactiveFlg
        vUiPBudgetGroup{
          uiMCategory1{
            categoryName
          }
          uiMCategory2{
            categoryName
          }
          uiMCategory3{
            categoryName
          }
        }
        budgetGroupId
        storeCd
        storeCdName
        startDate
        endDate
        monIndex
        tueIndex
        wedIndex
        thuIndex
        friIndex
        satIndex
        sunIndex
        engineMonIndex
        engineTueIndex
        engineWedIndex
        engineThuIndex
        engineFriIndex
        engineSatIndex
        engineSunIndex
        configuredFlg
        lastModifiedDatetime
        lastModifiedUserName
      }
    }
  }
}
`
      return this.helper.generateQueryString({
        rowQuery: rowQuery,
        resourceType: this.resourceType,
        where: where,
      })
    },
    _createWhere() {
      // TODO: category0カラムが追加され次第抽出条件のbudgetGroupIdをcategory0に変更する
      const TRAN_REF_ITEM_SEARCH_CONDITION: Where[] = [
        // 抽出条件
        { field: ['startDateNvl'], op: WhereOp.Le, value: [''] },
        { field: ['endDateNvl'], op: WhereOp.Ge, value: [''] },
        {
          field: ['vUiPBudgetGroup/category0'],
          op: WhereOp.In,
          value: [''],
        },
        // 出力条件
        { field: ['configuredFlg'], op: WhereOp.In, value: [''] },
        { field: ['inactiveFlgNvl'], op: WhereOp.In, value: [''] },
      ]
      const where = JSON.parse(JSON.stringify(TRAN_REF_ITEM_SEARCH_CONDITION))
      setWhereValue(where, 'startDateNvl', this.extractCondition.validData[1])
      setWhereValue(where, 'endDateNvl', this.extractCondition.validData[0])
      setWhereValue(
        where,
        'vUiPBudgetGroup/category0',
        this.extractCondition.chubunrui
      )
      setWhereValue(where, 'inactiveFlgNvl', [
        '-',
        '0', // 削除されていないデータは必ず出力する
        ...this.outputCondition.delOutput,
      ])
      setWhereValue(where, 'configuredFlg', this.outputCondition.extractTarget)
      console.log({ where })
      return where
    },
    _createOrderByString() {
      const orderBy: OrderBy[] = [
        {
          field: 'budgetGroupId',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'storeCd',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'startDate',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
      ]
      console.log({ orderBy })
      return this.helper.generateQueryOrderByString(orderBy)
    },
    _create_column_label_mapping() {
      const columnLabelMapping: ColumnLabel[] = [
        {
          from: '__update',
          to: '',
        },
        {
          from: 'inactiveFlg',
          to: '',
        },
        {
          from: 'vUiPBudgetGroup.uiMCategory1.categoryName',
          to: '',
        },
        {
          from: 'vUiPBudgetGroup.uiMCategory2.categoryName',
          to: '',
        },
        {
          from: 'vUiPBudgetGroup.uiMCategory3.categoryName',
          to: '',
        },
        {
          from: 'budgetGroupId',
          to: '',
        },
        {
          from: 'storeCd',
          to: '',
        },
        {
          from: 'storeCdName',
          to: '',
        },
        {
          from: 'startDate',
          to: '',
        },
        {
          from: 'endDate',
          to: '',
        },
        {
          from: 'monIndex',
          to: '',
        },
        {
          from: 'tueIndex',
          to: '',
        },
        {
          from: 'wedIndex',
          to: '',
        },
        {
          from: 'thuIndex',
          to: '',
        },
        {
          from: 'friIndex',
          to: '',
        },
        {
          from: 'satIndex',
          to: '',
        },
        {
          from: 'sunIndex',
          to: '',
        },
        {
          from: 'engineMonIndex',
          to: '',
        },
        {
          from: 'engineTueIndex',
          to: '',
        },
        {
          from: 'engineWedIndex',
          to: '',
        },
        {
          from: 'engineThuIndex',
          to: '',
        },
        {
          from: 'engineFriIndex',
          to: '',
        },
        {
          from: 'engineSatIndex',
          to: '',
        },
        {
          from: 'engineSunIndex',
          to: '',
        },
        {
          from: 'configuredFlg',
          to: '',
        },
        {
          from: 'lastModifiedDatetime',
          to: '',
        },
        {
          from: 'lastModifiedUserName',
          to: '',
        },
      ]
      console.log({ columnLabelMapping })
      return columnLabelMapping
    },
  },
})
